export default __webpack_public_path__ + "static/media/miguel.970184f2.JPG";